import React from 'react'
import type { FollowMeProfile } from '@core/Areas/FollowMe/types'

export const ProfileContext = React.createContext<
  | {
      isOnProfilePage: false
      profilePageId?: never
      scrollToDefaultProfileState?: never
    }
  | {
      isOnProfilePage: true
      profilePageId: FollowMeProfile['id']
      scrollToDefaultProfileState: () => void
    }
>({ isOnProfilePage: false })
